module.exports = __webpack_public_path__ + "img/ellipsis.ba418de0.svg";